export default __webpack_public_path__ + "static/media/mac-book-pro.dbc45944.png";